import React from "react";
import { useButtonStyles } from "../base/ui/components/web/Button";
import { useSelector } from "react-redux";
export default function NotAllowed() {
    const { classes: buttonClasses, cx } = useButtonStyles();
    const tegoServer = useSelector((s) => s["features/tego-server"]);
    const { defaultLogoUrl } = useSelector((s) => s["features/base/config"]);
    return (React.createElement("div", { style: {
            minHeight: "100vh",
            color: "white",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "2rem",
            gap: "2rem",
            background: "transparent"
        } },
        React.createElement("img", { src: defaultLogoUrl, alt: "Logo", style: {
                width: "140px",
                opacity: 0.85,
                filter: "drop-shadow(0 0 12px rgba(255,255,255,0.15))"
            } }),
        React.createElement("div", { style: {
                fontSize: "1.8rem",
                fontWeight: 600,
                opacity: 0.9
            } }, "Acceso restringido"),
        React.createElement("p", { style: {
                fontSize: "1.1rem",
                maxWidth: "420px",
                lineHeight: 1.5,
                opacity: 0.75
            } }, "Es posible que esta consulta asistida sea invalida o que usted no tenga una sesi\u00F3n activa."),
        tegoServer.isEnabled && (React.createElement("a", { href: `${tegoServer.urls.ui}login`, className: cx(buttonClasses.button, buttonClasses.large), style: {
                textDecoration: "none",
                padding: "0.8rem 2rem",
                borderRadius: "8px",
                fontSize: "1.1rem",
                boxShadow: "0 4px 18px rgba(0,0,0,0.4)"
            } }, "Iniciar sesi\u00F3n"))));
}
